import { Typography } from 'antd'
import classnames from 'classnames'

export default function MyTitle({ level = 3, small = false, medium = false, className, ...props }) {
  return (
    <Typography.Title
      level={level}
      className={classnames(className, {
        'font-size-small': small,
        'font-medium': medium,
      })}
      {...props}
    />
  )
}
